import de from 'emoji-picker-react/dist/data/emojis-de';
import en from 'emoji-picker-react/dist/data/emojis-en';
import es from 'emoji-picker-react/dist/data/emojis-es';
import fr from 'emoji-picker-react/dist/data/emojis-fr';
import pt from 'emoji-picker-react/dist/data/emojis-pt';

/** Locale dictionary shape used by emoji-picker-react's `emojiData` prop. */
type EmojiPickerLocaleData = typeof es;

/**
 * Map app locale language codes to emoji-picker-react locale dictionaries
 * (category labels and emoji search names).
 */
const EMOJI_DATA_BY_LANG: Record<string, EmojiPickerLocaleData> = {
  en,
  es,
  fr,
  pt,
  de,
};

/**
 * Returns the emoji-picker-react data dictionary for the given app locale
 * (e.g. 'es-AR', 'en', 'fr'). Uses the language subtag; falls back to Spanish.
 */
export function getEmojiPickerData(appLocale: string): EmojiPickerLocaleData {
  const lang = appLocale.substring(0, 2).toLowerCase();
  return EMOJI_DATA_BY_LANG[lang] ?? es;
}
